import { formatNumber } from "./formatNumber";

interface FormatMoneyOptions {
    currency?: string;
    currencyPosition?: "before" | "after";
}

export const formatMoney = (
    value: number,
    { currency = "$", currencyPosition = "before" }: FormatMoneyOptions = {},
) => {
    const sign = value < 0 ? "-" : "";
    const formattedValue = formatNumber(Math.abs(value).toFixed(2));

    return currencyPosition === "before"
        ? `${sign}${currency}${formattedValue}`
        : `${sign}${formattedValue} ${currency}`;
};
